// needs to remain in sync with server
enum NoteType {
  Call = "Call",
  Text = "Text",
  Email = "Email",
  Milestone = "Milestone",
  ActionItem = "Action Item",
  Comment = "Comment",
  Challenge = "Challenge",
  VideoCall = "Video Call",
  // System-generated marker: a coach sent direct financial aid from the Success
  // Queue. Rendered as an inline pill in the message thread (toThreadMessage).
  FinancialAidSent = "Financial Aid Sent",
}

export default NoteType;
